module.exports = __webpack_public_path__ + "static/media/SY.b7728bec.svg";